import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useAtomicSetter } from '@/composables/useAtomicSetter.js';

export const useUserDrawerStore = defineStore('user-drawer', () => {
  const userId = ref(null);

  const isOpen = computed(() => !!userId.value);

  const stateRefs = {
    userId,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const closeDrawer = () => {
    setAtomic('userId', null);
  };

  return {
    ...stateRefs,
    isOpen,
    setAtomic,
    closeDrawer,
  };
});
